import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-950 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950">
              <i className="ri-fire-fill text-xl"></i>
            </span>
            <span className="font-brand text-xl text-background-50">火狼动漫网</span>
          </div>
          <p className="text-sm text-background-300 leading-relaxed max-w-md">
            火狼动漫网专注于最新动漫资讯与热门动漫推荐，为动漫爱好者提供作品介绍、行业动态与丰富的内容资源，帮助你轻松发现值得一看的动漫作品。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50 mb-4">内容导航</h4>
          <ul className="space-y-2 text-sm text-background-300">
            <li>
              <Link to="/" className="hover:text-accent-400 transition-colors">
                首页
              </Link>
            </li>
            <li>
              <Link to="/news" className="hover:text-accent-400 transition-colors">
                动漫资讯
              </Link>
            </li>
            <li>
              <Link to="/anime" className="hover:text-accent-400 transition-colors">
                动漫作品
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-accent-400 transition-colors">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50 mb-4">内容声明</h4>
          <p className="text-sm text-background-300 leading-relaxed">
            本站所展示的资讯与作品信息均为内容演示，图片素材仅用于展示效果，不提供任何播放、下载或付费服务。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-400">
          <span>© {year} 火狼动漫网 · 保留所有权利</span>
          <span>本站内容仅供学习与交流，请勿用于商业用途</span>
        </div>
      </div>
    </footer>
  );
}